module.exports = {
      id: "fb-usage",
      viewBox: "0 0 20 20",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#fb",
      toString: function () {
        return this.url;
      }
    }